import React from "react";
import "../../style/Slide.css";
import "../../style/SpiceSlide.css";
import { useMediaQuery } from "@mui/material";
import { breakpoint } from "../../utils/responsiveUtils";
import SpiceController from "./SpiceController";
import SpiceContent from "./SpiceContent";
import {
  SPICE_TEXT_GROUPS,
  SPICE_TEXT_GROUPS_MB,
} from "../../utils/aboutUtils";
import { useSelector } from "react-redux";

export const getLabel = (steps, language) => {
  return steps.map((step) => step.name[language]);
};

export const getDesc = (steps, language) => {
  return steps.map((step) => step.description[language]);
};

function SpiceSlide({ steps, language, activeStep, animation, clicked, toBeClicked, handleStep }) {
  const mobile = useMediaQuery(breakpoint.mobile);
  const spiceLabel = useSelector((state) => state.reducer.aboutText.spiceLabel);

  const label = getLabel(steps, language);
  const description = getDesc(steps, language);

  return (
    <div style={{ display: "flex" }}>
      <div className="spice-container">
        <div className="spice-controller">
          <div className="cap-r15">{spiceLabel}</div>
          {mobile ? (
            <h1 className="spice-controller-text">
              <SpiceController
                groups={SPICE_TEXT_GROUPS_MB}
                label={label}
                steps={steps}
                language={language}
                activeStep={activeStep}
                clicked={clicked}
                toBeClicked={toBeClicked}
                handleStep={handleStep}
              />
            </h1>
          ) : (
            <div className="header-text spice-controller-text">
              <SpiceController
                groups={SPICE_TEXT_GROUPS}
                label={label}
                steps={steps}
                language={language}
                activeStep={activeStep}
                clicked={clicked}
                toBeClicked={toBeClicked}
                handleStep={handleStep}
              />
            </div>
          )}
        </div>
        {steps.map(
          (item, index) =>
            index === activeStep && (
              <SpiceContent
                key={item.id}
                item={item}
                animation={animation}
                description={description[index]}
              />
            )
        )}
      </div>
    </div>
  );
}

export default SpiceSlide;
